{
  "pages_editor.placeholder": "Write, or press '/' for commands",
  "pages_editor.commands": "Blocks and records",
  "pages_editor.insert_below": "Add a block below",
  "pages_editor.drag_handle": "Drag to move, or open block actions",
  "pages_editor.turn_into": "Turn into",
  "pages_editor.duplicate": "Duplicate",
  "pages_editor.copy_link": "Copy link to block",
  "pages_editor.link_copied": "Link copied",
  "pages_editor.copy_failed": "The link could not be copied.",
  "pages_editor.delete": "Delete",
  "pages_editor.strike": "Strikethrough",
  "pages_editor.inline_code": "Inline code",
  "pages_editor.turn.paragraph": "Text",
  "pages_editor.turn.heading1": "Heading 1",
  "pages_editor.turn.heading2": "Heading 2",
  "pages_editor.turn.heading3": "Heading 3",
  "pages_editor.turn.bullet": "Bulleted list",
  "pages_editor.turn.numbered": "Numbered list",
  "pages_editor.turn.checklist": "To-do list",
  "pages_editor.turn.toggle": "Toggle",
  "pages_editor.turn.quote": "Quote",
  "pages_editor.turn.code": "Code",
  "pages_editor.group.writing": "Basic blocks",
  "pages_editor.group.records": "Real records",
  "pages_editor.group.media": "Pages and files",
  "pages_editor.group.tools": "Views and tools",
  "pages_editor.cmd.paragraph": "Text",
  "pages_editor.cmd.paragraph_hint": "Plain writing.",
  "pages_editor.cmd.heading1": "Heading 1",
  "pages_editor.cmd.heading1_hint": "Large section title.",
  "pages_editor.cmd.heading2": "Heading 2",
  "pages_editor.cmd.heading2_hint": "Medium section title.",
  "pages_editor.cmd.heading3": "Heading 3",
  "pages_editor.cmd.heading3_hint": "Small section title.",
  "pages_editor.cmd.bullet": "Bulleted list",
  "pages_editor.cmd.bullet_hint": "An unordered list.",
  "pages_editor.cmd.numbered": "Numbered list",
  "pages_editor.cmd.numbered_hint": "An ordered list.",
  "pages_editor.cmd.checklist": "To-do list",
  "pages_editor.cmd.checklist_hint": "Tick boxes that stay in this page.",
  "pages_editor.cmd.toggle": "Toggle",
  "pages_editor.cmd.toggle_hint": "A section that folds away.",
  "pages_editor.cmd.quote": "Quote",
  "pages_editor.cmd.quote_hint": "Set a passage apart.",
  "pages_editor.cmd.code": "Code",
  "pages_editor.cmd.code_hint": "A monospaced block.",
  "pages_editor.cmd.divider": "Divider",
  "pages_editor.cmd.divider_hint": "A line between sections.",
  "pages_editor.cmd.table": "Table",
  "pages_editor.cmd.table_hint": "A simple content table.",
  "pages_editor.cmd.columns2": "Two columns",
  "pages_editor.cmd.columns2_hint": "Place blocks side by side.",
  "pages_editor.cmd.columns3": "Three columns",
  "pages_editor.cmd.columns3_hint": "Three blocks side by side.",
  "pages_editor.cmd.entity_new_hint": "Write a new record on this row.",
  "pages_editor.cmd.entity_existing_hint": "Find a record you already have.",
  "pages_editor.cmd.entity_task": "New task",
  "pages_editor.cmd.entity_task_existing": "Existing task",
  "pages_editor.cmd.entity_project": "New project",
  "pages_editor.cmd.entity_project_existing": "Existing project",
  "pages_editor.cmd.entity_plan": "New plan",
  "pages_editor.cmd.entity_plan_existing": "Existing plan",
  "pages_editor.cmd.entity_routine": "New routine",
  "pages_editor.cmd.entity_routine_existing": "Existing routine",
  "pages_editor.cmd.entity_period": "New period",
  "pages_editor.cmd.entity_period_existing": "Existing period",
  "pages_editor.cmd.entity_note": "New note",
  "pages_editor.cmd.entity_note_existing": "Existing note",
  "pages_editor.cmd.entity_life_area_existing": "Existing life area",
  "pages_editor.cmd.entity_life_item_existing": "Existing life record",
  "pages_editor.cmd.page": "Page link",
  "pages_editor.cmd.page_hint": "Link another page of yours.",
  "pages_editor.cmd.image": "Image",
  "pages_editor.cmd.image_hint": "Attach a picture.",
  "pages_editor.cmd.file": "File",
  "pages_editor.cmd.file_hint": "Attach a document.",
  "pages_editor.cmd.view": "Task view",
  "pages_editor.cmd.view_hint": "Live results, not a copy.",
  "pages_editor.cmd.calendar": "Calendar",
  "pages_editor.cmd.calendar_hint": "Your real schedule, in place.",
  "pages_editor.cmd.life_table": "Life table",
  "pages_editor.cmd.life_table_hint": "Show a table you track.",
  "pages_editor.cmd.focus": "Focus timer",
  "pages_editor.cmd.focus_hint": "Start a focus session here."
}
